import { useEffect, useState } from 'react';
import { YField, YSelect } from '../../../../components/yool/YoolPrimitives';
import { getCompanias } from '../../../../services/divinaProductsService';
import { useSupabaseClient } from '../../../../lib/supabase';

export default function PasoCompania({ value, onChange }) {
  const supa = useSupabaseClient();
  const [companias, setCompanias] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    getCompanias(supa)
      .then((data) => { if (!ignore) setCompanias(data); })
      .catch((error) => console.warn('Error al obtener compañías:', error))
      .finally(() => { if (!ignore) setLoading(false); });
    return () => { ignore = true; };
  }, [supa]);

  return (
    <YField label="Compañía" required>
      <YSelect
        data-testid="select-compania"
        value={value?.compania_id || ''}
        onChange={(e) => onChange({ compania_id: e.target.value })}
        disabled={loading}
      >
        <option value="">{loading ? 'Cargando...' : 'Selecciona compañía'}</option>
        {companias.map((c) => (
          <option key={c.id} value={c.id}>{c.nombre_corto}</option>
        ))}
      </YSelect>
    </YField>
  );
}
